import React from 'react'

import { useAuth } from 'utils/auth'
import { setStoresNameByUserId } from 'utils/store'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { STORES_WITH_STORAGE_KEY } from 'app/KinerjaPenilikPegawaiPage/stores/kinerja-penilik-pegawai'

/**
 * To prevent same Draft used by different user & different period
 */

export const useStoreByUserId = () => {
  const { session } = useAuth()
  const { period, isHavePeriod } = usePeriodContext()

  React.useEffect(() => {
    if (Boolean(session?.user?.id) && isHavePeriod) {
      setStoresNameByUserId(
        STORES_WITH_STORAGE_KEY,
        `${session?.user?.id}-${period.id}`
      )
    }
  }, [isHavePeriod, period.id, session?.user?.id])
}
